import API_PATH from '@/constants/apiPath'
import GRAPH_TEMPLATES from '@/constants/graphTemplates'
import cloneDeep from 'lodash/cloneDeep'

const state = {
    clickTrendLineChartOptions: {
        xAxis: {
            type: 'category',
            data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
            type: 'value'
        },
        series: [
            {
                data: [150, 230, 224, 218, 135, 147, 260],
                type: 'line',
                lineStyle: {
                    color: '#9F9F9F'
                },
                label: {
                    show: true
                }
            }
        ]
    },
    demographicChartOptions: cloneDeep(GRAPH_TEMPLATES.donutChartWithSideLegend),
    telcoChartOptions: cloneDeep(GRAPH_TEMPLATES.donutChartWithSideLegend),
    deviceChartOptions: cloneDeep(GRAPH_TEMPLATES.donutChartWithSideLegend),
    browserChartOptions: cloneDeep(GRAPH_TEMPLATES.donutChartWithSideLegend),
    emptyState: {
        demograph: false,
        telco: false,
        device: false,
        browser: false
    }
}

const getters = {
    getClickTrend: (state) => state.clickTrendLineChartOptions,
    getDemographicClicks: (state) => state.demographicChartOptions,
    getTelcoClicks: (state) => state.telcoChartOptions,
    getDeviceClicks: (state) => state.deviceChartOptions,
    getBrowserClicks: (state) => state.browserChartOptions,
    getEmptyState: (state) => state.emptyState
}

const mutations = {
    POPULATE_CLICK_TREND: (state, payload) => {
        state.clickTrendLineChartOptions.xAxis.data = Object.keys(payload.clickTrends)
        state.clickTrendLineChartOptions.series[0].data = Object.values(payload.clickTrends)
    },
    POPULATE_TYPE_CLICKS: (state, payload) => {
        if (payload.type === 'country' || payload.type === 'city' || payload.type === 'state') {
            if (payload.type === 'country') {
                state.demographicChartOptions.series[0].name = 'Country'
            } else if (payload.type === 'city') {
                state.demographicChartOptions.series[0].name = 'City'
            } else {
                state.demographicChartOptions.series[0].name = 'State'
            }
            if (payload.data.length) {
                state.emptyState.demograph = false
                state.demographicChartOptions.series[0].data = payload.data
                state.demographicChartOptions.legend.formatter = function (name) {
                    const dataItem = state.demographicChartOptions.series[0].data.find(item => item.name === name)
                    return name + ' - ' + dataItem.value
                }
            } else {
                state.emptyState.demograph = true
            }
        } else if (payload.type === 'telco') {
            if (payload.data.length) {
                state.emptyState.telco = false
                state.telcoChartOptions.series[0].name = 'Telecom'
                state.telcoChartOptions.series[0].data = payload.data
                state.telcoChartOptions.legend.formatter = function (name) {
                    const dataItem = state.telcoChartOptions.series[0].data.find(item => item.name === name)
                    return name + ' - ' + dataItem.value
                }
            } else {
                state.emptyState.telco = true
            }
        } else if (payload.type === 'browser' || payload.type === 'os') {
            if (payload.type === 'browser') {
                state.browserChartOptions.series[0].name = 'Browser'
            } else {
                state.browserChartOptions.series[0].name = 'OS'
            }
            if (payload.data.length) {
                state.emptyState.browser = false
                state.browserChartOptions.series[0].data = payload.data
                state.browserChartOptions.legend.formatter = function (name) {
                    const dataItem = state.browserChartOptions.series[0].data.find(item => item.name === name)
                    return name + ' - ' + dataItem.value
                }
            } else {
                state.emptyState.browser = true
            }
        } else {
            if (payload.type === 'device') {
                state.deviceChartOptions.series[0].name = 'Device'
            } else {
                state.deviceChartOptions.series[0].name = 'Device make'
            }
            if (payload.data.length) {
                state.emptyState.device = false
                state.deviceChartOptions.series[0].data = payload.data
                state.deviceChartOptions.legend.formatter = function (name) {
                    const dataItem = state.deviceChartOptions.series[0].data.find(item => item.name === name)
                    return name + ' - ' + dataItem.value
                }
            } else {
                state.emptyState.device = true
            }
        }
    }
}

const actions = {
    async fetchClickTrendAnalytics ({ commit }, payload) {
        try {
            const resp = await this.$axios.post(API_PATH.analytics.clicksTrend, payload)
            if (resp && resp.data) {
                commit('POPULATE_CLICK_TREND', resp.data)
            }
        } catch (err) {
            console.log(err)
        }
    },
    async fetchTypeAnalytics ({ commit }, payload) {
        try {
            if (payload.type) {
                const resp = await this.$axios.post(API_PATH.analytics.typeClicks, payload)
                if (resp && resp.data) {
                    commit('POPULATE_TYPE_CLICKS', { data: resp.data, type: payload.type })
                }
            }
        } catch (err) {
            console.log(err)
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
